var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 15.6C13 19.1896 15.9102 22.1 19.5 22.1C23.0898 22.1 26 19.1896 26 15.6C26 12.0104 23.0898 9.09998 19.5 9.09998C15.9102 9.09998 13 12.0104 13 15.6ZM16.25 15.6C16.25 17.3956 17.705 18.85 19.5 18.85C21.295 18.85 22.75 17.3956 22.75 15.6C22.75 13.8044 21.295 12.35 19.5 12.35C17.705 12.35 16.25 13.8044 16.25 15.6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 0C30.2695 0 39 8.73068 39 19.5C39 30.2693 30.2695 39 19.5 39C8.7305 39 0 30.2693 0 19.5C0 8.73068 8.7305 0 19.5 0ZM35.4545 19.5C35.4545 23.205 34.1915 26.6157 32.0722 29.3244C29.1571 25.5078 24.5588 23.0455 19.3857 23.0455C14.2797 23.0455 9.73369 25.444 6.81347 29.1756C4.76332 26.4916 3.54545 23.1376 3.54545 19.5C3.54545 10.6878 10.6885 3.54545 19.5 3.54545C28.3115 3.54545 35.4545 10.6878 35.4545 19.5ZM19.5 35.4545C23.3117 35.4545 26.8113 34.1179 29.5554 31.8878C27.3115 28.6845 23.5931 26.5909 19.3857 26.5909C15.2306 26.5909 11.5523 28.6331 9.30008 31.7691C12.0654 34.0701 15.6211 35.4545 19.5 35.4545Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d732833389b0f3fd5558d759b3e670eb.svg";
export { ForwardRef as ReactComponent };